import { useId } from "react";
import type { InputProps } from "./Input";

const Checkbox = ({ label, registerFct, ...props }: InputProps) => {
  const generatedId = useId();
  const id = props.id ?? generatedId;
  return (
    <div className="flex items-center py-2" style={props.disabled ? { opacity: 0.5 } : {}}>
      <input
        {...props}
        id={id}
        type="checkbox"
        className={props.disabled ? "cursor-not-allowed" : "cursor-pointer"}
        {...(registerFct && registerFct())}
      ></input>
      <label
        htmlFor={id}
        className={`mx-2 block text-sm text-gray-700 ${
          props.disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
